import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { AuthService } from '../core/auth.service';

@Component({
  selector: 'app-login',
  template: `
    <div class="card login-panel">
      <div class="card-img-top user-image text-center">
        <i class="fa fa-user-circle"></i>
      </div>
      <form class="p-3" #loginForm="ngForm" (ngSubmit)="onSubmit(loginForm)">
        <div class="form-group">
          <input type="text" class="form-control" [(ngModel)]="loginModel.company" name="company" required placeholder="Company">
        </div>
        <button type="submit" class="btn btn-primary btn-block" [disabled]="loginForm.form.invalid">Continue Login</button>
      </form>
    </div>
  `,
  styles: [`
    :host {
      height: 100%;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-align: center;
      align-items: center;
      -ms-flex-pack: center;
      justify-content: center;
      background-color: #aaa;
    }
    .login-panel {
      background-color: #fff;
      width: 300px;
    }
    .user-image {
      font-size: 6rem;
    }
  `]
})
export class LoginSSOComponent {

  loginModel: any = {};

  constructor(
    private router: Router,
    private notificationsService: NotificationsService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.authService.InitializeAuthService();
  }

  onSubmit(loginForm) {
    let ssotoken = "";
    let { company } = this.loginModel;
    this.authService.ssoAuthService.authenticate().then(
      (res: any) => {
        ssotoken = res.accessToken;
        if(ssotoken){
          this.authService.loginSSO(company, ssotoken).then((success) => {
            if (success) {
              this.router.navigate(['/']);
            } else {
              this.notificationsService.error('Login failed');
            }
          });
        } else{
          this.notificationsService.error('Invalid Token');
        }
      },
      (err) => {
        this.notificationsService.error(err.message);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login-sso.component.ts